import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/pjm-reporting",
    name: "PJM Reporting",
    component: () => import("./pjmReporting.vue"),
  },
  {
    path: "/hvac-availability",
    name: "HVAC Availability Calendar",
    component: () => import("./hvacCalendarDisplay.vue"),
  },
  {
    path: "/hvac-availability-admin",
    name: "HVAC Availability Admin",
    component: () => import("./hvacAvailabilityAdmin.vue"),
  },
] satisfies RouteRecordRaw[];
